var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgX = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 41,
  height: 41,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M31.226 11.864a1.662 1.662 0 0 0-2.35-2.35l-8.142 8.141-8.142-8.141a1.662 1.662 0 0 0-2.35 2.35l8.142 8.141-8.142 8.142a1.662 1.662 0 0 0 2.35 2.35l8.142-8.142 8.141 8.142a1.662 1.662 0 0 0 2.35-2.35l-8.141-8.142 8.142-8.141Z",
  fill: "#00546F"
})));
export default SvgX;